import React from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import * as screens from '../../modules';
import Layout from '../Layout';
import routes from './routingMap';

export default function StudentRoute() {
  // comentado temporal const [closeAcademicCalendar]: any = useState(false);
  const { isSimulator } = useSelector((state: any) => state.simulator);
  return (
    <BrowserRouter>
      <Layout
      // openAcademicCalendar={closeAcademicCalendar}
      // handleOpenModal={() => {}}
      />
      <div style={{ marginBottom: isSimulator ? 70 : 0 }}>
        <Switch>
          {/* <Route path={routes.logout} component={screens.Logout} /> */}
          <Route
            exact
            path={routes.student.main.home}
            component={screens.Home}
          />
          <Route
            exact
            path={routes.student.courses.advanceCurriculum}
            component={screens.AcademicInformation}
          />

          <Route
            exact
            path={routes.student.main.institutionalInformation}
            component={screens.InstitutionalInformationModuleController}
          />
          <Route
            path={routes.student.schedule.home}
            component={screens.Schedule}
          />
          <Route
            exact
            path={routes.student.procedures.home}
            component={screens.ProceduresHome}
          />
          <Route
            exact
            path={routes.student.procedures.listScholarshipsDiscounts}
            component={screens.ScholarshipsDiscountsViewController}
          />
          <Route
            exact
            path={routes.student.procedures.list}
            component={screens.ProceduresListViewController}
          />
          <Route
            exact
            path={routes.student.procedures.created}
            component={screens.ProceduresCreatedController}
          />
          <Route
            exact
            path={routes.student.procedures.createdEmbedded}
            component={screens.ProceduresCreatedEmbeddedController}
          />
          <Route
            exact
            path={routes.student.procedures.charge}
            component={screens.ProcedureAmountViewController}
          />
          {/* RUTAS DE ACTUALIZACIONDE FOTO */}
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.updatephoto
                .procedureinfo
            }
            component={screens.UpdatePhotoViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.updatephoto
                .procedureregister
            }
            component={screens.UpdatePhotoRegisterViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.updatephoto
                .procedureprogress
            }
            component={screens.UpdatePhotoProgressViewController}
          />

          {/* RUTAS CARNET UNIVERSITARIO */}
          <Route
            exact
            path={
              routes.student.procedures.categories.requests
                .issuancefuniversitycard.procedureinfo
            }
            component={screens.IssuanceUniversityCardInfoViewController}
          />

          <Route
            exact
            path={
              routes.student.procedures.categories.requests
                .issuancefuniversitycard.procedureregister
            }
            component={screens.IssuanceUniversityCardRegisterViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests
                .issuancefuniversitycard.procedureprogress
            }
            component={screens.IssuanceUniversityCardProgressViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.certificateOfStudies
                .procedureinfo
            }
            component={screens.CertificateOfStudiesController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.certificateOfStudies
                .procedureprogress
            }
            component={screens.CertificateOfStudiesProgressViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.certificateOfStudies
                .procedureregister
            }
            component={screens.CertificateOfStudiesRegisterViewController}
          />
          {/* COMENTADO PARA VERSION DE LANZAMIENTO */}
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.retirementperiod
                .procedureinfo
            }
            component={screens.RetirementPeriodViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.retirementperiod
                .procedureregister
            }
            component={screens.RetirementPeriodRegisterViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.retirementperiod
                .procedureprogress
            }
            component={screens.RetirementPeriodProgressViewController}
          />
          {/* COMENTADO PARA VERSION DE LANZAMIENTO */}
          {/*  <Route
            exact
            path={
              routes.student.procedures.categories.requests
                .changecareercampusmodality.procedureinfo
            }
            component={screens.ChangeCareerCampusModalityInfoViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests
                .changecareercampusmodality.procedureregister
            }
            component={screens.ChangeCareerCampusModalityRegisterViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests
                .changecareercampusmodality.procedureprogress
            }
            component={screens.ChangeCareerCampusModalityProgressViewController}
          /> */}
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.fullCycleDiscount
            }
            component={screens.FullCycleDiscountViewController}
          />
          {/* <Route
            exact
            path={
              routes.student.procedures.categories.requests.validationInsurance
            }
            component={screens.RequestViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests
                .validationCardVaccination
            }
            component={screens.RequestViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.fullCycleDiscount
            }
            component={screens.RequestViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.rectificationNotes
            }
            component={screens.RequestViewController}
          />
          <Route
            exact
            path={routes.student.procedures.categories.requests.retreatCourse}
            component={screens.RequestViewController}
          />
          <Route
            exact
            path={routes.student.procedures.categories.requests.examStragglers}
            component={screens.RequestViewController}
          /> */}
          <Route
            exact
            path={
              routes.student.procedures.categories.certificates
                .certificatetype01.procedureinfo
            }
            component={screens.CertificateType01ViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.certificates
                .certificatetype01.procedureregister
            }
            component={screens.CertificateType01RegisterViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.certificates
                .certificatetype01.procedureprogress
            }
            component={screens.CertificateType01ProgressViewController}
          />
          <Route
            exact
            path={routes.student.procedures.categories.tickets.register}
            component={screens.RegisterTicketController}
          />
          {/* <Route
            exact
            path={routes.student.bse.home}
            component={screens.BseController}
          /> */}

          <Route
            exact
            path={routes.student.procedures.categories.scholarships.bse.home}
            component={screens.BSEviewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.scholarships.bse
                .procedureRegisterForms
            }
            component={screens.FormIndexViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.scholarships.bse
                .supportingDocuments
            }
            component={screens.SupportingDocumentsController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.scholarships.bse.register
            }
            component={screens.RegisterBseController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.scholarships.bse.progress
            }
            component={screens.ProgressBseController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.scholarships.agreements.info
            }
            component={screens.AgreementsInfoViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.scholarships.agreements
                .register
            }
            component={screens.AgreementsRegisterViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.scholarships.agreements
                .progress
            }
            component={screens.AgreementsProgressViewController}
          />
          <Route
            exact
            path={routes.student.events.home}
            component={screens.EventsViewController}
          />
          <Route
            exact
            path={routes.student.events.detail}
            component={screens.EventDetailViewController}
          />
          {/* COMENTADO PARA VERSION DE LANZAMIENTO */}
          <Route
            exact
            path={routes.student.reinforcements.home}
            component={screens.ReinforcementsViewController}
          />
          <Route
            exact
            path={routes.student.reinforcements.detail}
            component={screens.ReinforcementsViewDetailController}
          />
          <Route
            exact
            path={routes.student.courses.home}
            component={screens.CoursesViewController}
          />
          <Route
            exact
            path={routes.student.courses.myCourses}
            component={screens.MyCoursesViewController}
          />
          <Route
            exact
            path={routes.student.courses.notesRecord}
            component={screens.NotesRecordNewController}
          />
          <Route
            exact
            path={routes.student.courses.notesRecordNew}
            component={screens.NotesRecordNewController}
          />
          <Route
            exact
            path={routes.student.courses.advanceCurriculum}
            component={screens.AcademicInformation}
          />
          <Route
            exact
            path={routes.student.courses.advanceCurriculumOld}
            component={screens.AcademicInformation}
          />
          <Route
            exact
            path={routes.student.courses.advanceCurriculumDetalle}
            component={screens.AdvanceCurriculumControllerCourses}
          />
          <Route
            exact
            path={routes.student.courses.progressiveCertifications}
            component={screens.ProgressiveCertifications}
          />
          <Route
            exact
            path={routes.student.payments.home}
            component={screens.PaymentsViewController}
          />
          <Route
            exact
            path={routes.student.payments.historial}
            component={screens.PaymentHistorialViewController}
          />
          <Route
            exact
            path={routes.student.payments.detail}
            component={screens.PaymentDetailsViewController}
          />
          <Route
            exact
            path={routes.student.payments.options}
            component={screens.PaymentOptionsViewController}
          />
          <Route
            exact
            path={routes.student.payments.balance}
            component={screens.PaymentsBalanceViewController}
          />
          <Route
            exact
            path={routes.student.payments.online}
            component={screens.PayOnlineViewController}
          />
          <Route
            exact
            path={routes.student.services.home}
            component={screens.ServicesViewController}
          />
          <Route
            exact
            path={routes.student.means.home}
            // component={screens.EmbeddedViewController}
            component={screens.MeanViewController}
          />
          <Route
            exact
            path={routes.student.reinforcements.embedded}
            component={screens.ReinforcementsEmbViewController}
          />
          <Route
            exact
            path={routes.student.main.registrationShift}
            component={screens.RegistrationShiftController}
          />
          <Route
            exact
            path={routes.student.main.courseCatalog}
            component={screens.CourseCatalogController}
          />
          <Route
            exact
            path={routes.student.main.examRol}
            component={screens.ExamRolController}
          />
          <Route
            exact
            path={routes.student.main.enrollmentSurvey}
            component={screens.EnrollmentSurveyController}
          />
          {/* Reincorporacion */}
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.reincorporation.info
            }
            component={screens.ReincorporationInfoViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.reincorporation
                .register
            }
            component={screens.ReincorporationRegisterViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.reincorporation
                .progress
            }
            component={screens.ReincorporationProgressViewController}
          />
          {/* Examen Rezagados */}
          <Route
            exact
            path={routes.student.procedures.categories.requests.lateExamen.info}
            component={screens.LateExamInfoViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.lateExamen.register
            }
            component={screens.LateExamRegisterViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.lateExamen.progress
            }
            component={screens.LateExamProgressViewController}
          />
          {/* cambio de opcion de estudio */}
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.changeStudiesOption
                .procedureinfo
            }
            component={screens.ChangeStudiesOptionInfoViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.changeStudiesOption
                .procedureregister
            }
            component={screens.ChangeStudiesOptionRegisterViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.changeStudiesOption
                .procedureprogress
            }
            component={screens.ChangeStudiesOptionProgressViewController}
          />
          {/* Retiro de curso */}
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.retreatCourse.info
            }
            component={screens.RetreatCourseViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.retreatCourse
                .register
            }
            component={screens.RetreatCourseRegisterViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.retreatCourse
                .progress
            }
            component={screens.RetreatCourseProgressViewController}
          />
          {/* Rectifcacion de notas */}
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.rectificationOfNotes
                .info
            }
            component={screens.RectificationInfoViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.rectificationOfNotes
                .register
            }
            component={screens.RectificationRegisterViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.rectificationOfNotes
                .progress
            }
            component={screens.RectificationProgressViewController}
          />
          {/* PSE */}
          <Route
            exact
            path={routes.student.procedures.categories.requests.pse.info}
            component={screens.PseInfoViewController}
          />
          <Route
            exact
            path={routes.student.procedures.categories.requests.pse.register}
            component={screens.PseRegisterViewController}
          />
          <Route
            exact
            path={routes.student.procedures.categories.requests.pse.progress}
            component={screens.PseProgressViewController}
          />
          {/* Constancia de Egresado */}
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.GraduatedCertificate
                .info
            }
            component={screens.GraduatedCertificateViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.GraduatedCertificate
                .register
            }
            component={screens.GraduatedCertificatedRegisterController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.GraduatedCertificate
                .progress
            }
            component={screens.GraduatedCertificatedProgressViewController}
          />
          <Route
            exact
            path={routes.student.reservation.tablets.register}
            component={screens.ReservationRegisterController}
          />
          <Route
            exact
            path={routes.student.reservation.computers.register}
            component={screens.ReservationRegisterController}
          />
          <Route
            exact
            path={routes.student.reservation.rooms.register}
            component={screens.ReservationRegisterController}
          />

          <Route
            exact
            path={routes.student.means.detail}
            component={screens.TabletDetailViewController}
          />
          <Route
            exact
            path={routes.profile.home}
            component={screens.ProfileViewController}
          />
          <Route
            exact
            path={routes.profile.personalInformation}
            component={screens.PersonalInformationViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.employabilityCharter
                .info
            }
            component={screens.EmployabilityCharterViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.employabilityCharter
                .register
            }
            component={screens.EmployabilityCharterRegisterViewController}
          />
          <Route
            exact
            path={
              routes.student.procedures.categories.requests.employabilityCharter
                .progress
            }
            component={screens.EmployabilityCharterProgressViewController}
          />

          <Redirect to="/inicio" />
        </Switch>
      </div>
    </BrowserRouter>
  );
}
